import { render, staticRenderFns } from "./CreateLogin.html?vue&type=template&id=124662ae&scoped=true&"
import script from "./CreateLogin.vue?vue&type=script&lang=ts&"
export * from "./CreateLogin.vue?vue&type=script&lang=ts&"
import style0 from "./CreateLogin.scss?vue&type=style&index=0&id=124662ae&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124662ae",
  null
  
)

export default component.exports